
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/sounds",
      function () {
        return require("private-next-pages/solutions/sounds.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/sounds"])
      });
    }
  